import { Theme } from '../theming/charting/theme';
import { Factory } from '../../services/Factory';
import { ValueType } from './valueType';
import { Utilities } from '../../Utilities';

interface IPieChartScope extends angular.IScope {
  data: any[];
  drilled: boolean;
  reset: () => void;
}

export class PieChart implements angular.IDirective {
  public restrict: string = 'E';
  public link: (scope: IPieChartScope, element: angular.IAugmentedJQuery, attrs) => void;
  public template: string;
  public scope = {data: '=ngModel'};
  public require = ['ngModel'];

  constructor() {
    this.template = `
<div style='width: 100%; height: 100%'>
    <div style="height: 36px">
        <i class='fa fa-undo' ng-click="reset()" ng-show='viewingOtherSegment' style='font-size: 36px; cursor: pointer; top: -5px; opacity: 0.5'></i>
    </div>
    <div class="pie-chart-canvas"></div>
</div>`;
    this.link = (scope: IPieChartScope, element: angular.IAugmentedJQuery, attrs) => {
        const data = _.sortBy(scope.data, "value");
        const total = _.reduce(data, (s, v) => s + v.value, 0);
        const smallSegments = [];

        let percentage = 0;

        const allSegments = _.filter(data, d => {
          if (d.label === "") {
            d.label = "Unknown";
          }

          if (smallSegments.length === data.length - 2) {
            return true;
          }

          if (percentage < 0.03) {
            percentage += d.value / total;
            smallSegments.push(d);

            return false;
          }

          return true;
        });

        if (smallSegments.length > 0) {
          allSegments.push(_.reduce(smallSegments, (s, v) => ({label: "Other", value: s.value + v.value})));
        }


        const pie = c3.generate({
          bindto: element.find('.pie-chart-canvas')[0],
          data: {
            columns: [["_", null]],
            type: "pie",
            onclick: d => {
              if (d.id === "Other") {
                scope.viewingOtherSegment = true;
                scope.$applyAsync();

                pie.load({
                  columns: smallSegments.map(d => [d.label, d.value])
                });
                pie.unload({
                  ids: allSegments.map(d => d.label)
                });
              } else {
                scope.$emit("chartItemSelected", element, {id: d.id});
              }
            }
          },
          color: {
            pattern: ["#c3c3c3", ...Theme.Colors]
          },
          tooltip: {
            format: {
              value: value => attrs.valueType === ValueType[ValueType.Bytes] ? Utilities.formatBytes(+value) : d3.format(",d")(+value)
            }
          },
          legend: {
            hide: ["_"],
          },
          interaction: {
            brighten: false
          }
        });

        setTimeout(() => {
          pie.load({
            columns: allSegments.map(d => [d.label, d.value]),
            colors: {"Other": "#c3c3c3"}
          });
        }, 300);

        scope.reset = () => {
          scope.viewingOtherSegment = false;
          scope.$applyAsync();

          pie.load({
            columns: allSegments.map(d => [d.label, d.value])
          });
          pie.unload({
            ids: smallSegments.map(d => d.label)
          });
        };
      }
  }
}

frontendApp.directive("iioPieChart", [Factory.Create(PieChart)]);
